export default __webpack_public_path__ + "static/media/bussiness.4a45c389.jpg";